// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Fabelwesen „Glühwürmchen": schwebt in einer S-Kurve hoch, Salbei-Glühen pulsiert.
export default function Gluehwuermchen() {
  return (
    <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <g
        className="wurm"
        fill="none"
        stroke="var(--tanne)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Glühen (pulsiert) */}
        <g className="wurm-glow">
          <circle cx="60" cy="74" r="19" fill="var(--salbei)" stroke="none" opacity="0.45" />
        </g>
        {/* Hinterleib (das Licht) */}
        <ellipse cx="60" cy="74" rx="11" ry="14" fill="var(--creme)" />
        {/* Flügel */}
        <g className="wurm-fluegel">
          <path d="M51 48 C36 42 28 48 26 58 C34 62 46 58 52 52 Z" fill="var(--salbei)" opacity="0.8" />
          <path d="M69 48 C84 42 92 48 94 58 C86 62 74 58 68 52 Z" fill="var(--salbei)" opacity="0.8" />
        </g>
        {/* Mittelteil */}
        <ellipse cx="60" cy="52" rx="9" ry="11" fill="var(--sand)" />
        {/* Kopf */}
        <circle cx="60" cy="35" r="7" fill="var(--sand)" />
        {/* Fühler */}
        <path d="M56 29 C52 24 50 22 46 20 M64 29 C68 24 70 22 74 20" />
        {/* Augen */}
        <circle cx="57" cy="34" r="1.8" fill="var(--tanne)" stroke="none" />
        <circle cx="63" cy="34" r="1.8" fill="var(--tanne)" stroke="none" />
        {/* kleine Lichtspuren */}
        <path d="M60 96 L60 102 M44 91 L40 96 M76 91 L80 96" stroke="var(--salbei)" />
      </g>
    </svg>
  )
}
